export default __webpack_public_path__ + "img/bg_visa-7c4e64cf26ec5d43a58f4796c8b99a56.png";